module.exports = __webpack_public_path__ + "files/a4470dc4216d37c4ea6b563f1e1984d1.png";